export default "__VITE_ASSET__ZkZQUE0B__"